var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"c-loading"}},[_c('div',{staticClass:"c-loading"})])
}
var staticRenderFns = []

export { render, staticRenderFns }